<template>
  <confirm :title="$t('Verify your email')" :displayed="displayed" @close="$emit('close')">
    <div slot="body" class="body">
      <span v-t>
        Before you start inviting clients, verify your email. To verify, check your inbox for a verification email.
        If you need help,
      </span>
      <a v-t class="contact" href="#" @click="showIntercom()">contact us</a>.
    </div>
    <div slot="footer" class="footer">
      <button v-t type="button" @click="$emit('close')">Okay</button>
      <button v-t type="button" class="silver" @click="resendEmail()">Resend email</button>
    </div>
  </confirm>
</template>

<script>
import { intercom } from '@/lib/analytics';
import { confirm } from '@/components/layout';
import { mapActions } from '@/lib/vue';
import errorStore from '@/store/error';

const _ = { intercom, errorStore };

export default {
  _,
  components: { confirm },
  props: {
    displayed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(['resendVerificationEmail']),
    async resendEmail() {
      try {
        await this.resendVerificationEmail();
        this.$emit('close');
      } catch (exception) {
        _.errorStore.addError();
      }
    },
    showIntercom() {
      _.intercom('show');
    },
  },
};
</script>

<style lang="scss" scoped>

  .contact {
    margin-left: 0.25rem;
  }

  .footer {
    display: flex;
    width: 100%;

    button {
      width: 100%;

      &:first-child {
        margin-right: 0.5rem;
      }
    }
  }

</style>
